import { getApiBaseUrl } from '../../env'

export function init(cb) {
  loadScript('/libs/uni.webview.1.5.5.js')
  document.addEventListener('UniAppJSBridgeReady', function () {
    uni.webView.getEnv(function (res) {
      console.log('当前环境：' + JSON.stringify(res))
    })

    // 检测小程序环境版本，设置运行时 API 域名
    const apiBaseUrl = getApiBaseUrl()
    if (apiBaseUrl) {
      window.__API_BASE_URL__ = apiBaseUrl
      console.log('[env] 已设置 API 域名:', window.__API_BASE_URL__)
    }

    let back = uni.navigateBack
    uni.navigateBack = (...args) => {
      if (window.history.length === 1) {
        buildPost('navigateBack')
      } else {
        back.apply(uni, args)
      }
    }
    cb && cb()
  })
}

function loadScript(src, async = true) {
  const $script = document.createElement('script')
  $script.async = async
  $script.src = src
  document.body.appendChild($script)
  return new Promise((resolve, reject) => {
    $script.onload = () => {
      resolve(true)
    }
  })
}

export function scanCode(callBack) {
  buildPost('scanCode', callBack)
}
export function getLocation(callBack) {
  var name = 'getGPSBack' + new Date().getTime()
  callBack =
    typeof callBack === 'function'
      ? callBack
      : function (res) {
          console.log(res)
        }
  var callParams = {}
  callParams.data = ''
  const cb = function (appData) {
    appData = appData ? JSON.parse(appData) : {}
    if (typeof appData.code === 'undefined' || appData.code != 0 || Object.keys(appData.data).length <= 0) {
      callParams.success = false
      callParams.msg = appData.msg || '无法获取错误信息'
      callBack(callParams)
      return
    }
    callParams.success = true
    callParams.data = appData.data || {}
    callParams.msg = appData.msg
    callBack(callParams)
  }

  postMsg('getGPS', name, window.currentFrameIndex, cb)
}

export function share(data, callBack) {
  buildPost('share', callBack, null, data)
}

export function setClipboardData(data, callBack) {
  buildPost('setClipboardData', callBack, null, { data })
}

export function choosePhoto(callBack) {
  buildPost('choosePhoto', callBack)
}

export function chooseMap(callBack) {
  buildPost('chooseMap', callBack)
}
export function openLocation(data, callBack) {
  buildPost('openLocation', callBack, null, data)
}
export function login(callBack) {
  buildPost('login', callBack)
}

function buildPost(name, callBack, customCB, data) {
  var cbName = name + new Date().getTime()
  callBack =
    typeof callBack === 'function'
      ? callBack
      : function (res) {
          console.log(res)
        }
  var callParams = {}
  callParams.data = ''
  const cb = function (appData) {
    appData = appData ? JSON.parse(appData) : {}
    if (typeof appData.code === 'undefined' || appData.code != 0) {
      callParams.success = false
      callParams.msg = appData.msg || '无法获取错误信息'
      callBack(callParams)
      return
    }
    callParams.success = true
    callParams.data = appData.data || {}
    callParams.msg = appData.msg
    callBack(callParams)
  }

  postMsg(name, cbName, window.currentFrameIndex, customCB || cb, data)
}

function postMsg(type, name, index, cb, data) {
  let postMessage = uni.postMessage || uni.webView.postMessage
  postMessage({
    data: {
      action: type,
      cb: name,
      data,
      index
    }
  })
  if (index || index === 0) {
    window.parent.frames[index][name] = function (res) {
      cb && cb(decodeURIComponent(res))
    }
  } else {
    window[name] = function (res) {
      cb && cb(decodeURIComponent(res))
    }
  }
}
